module.exports = __webpack_public_path__ + "img/valley_oak_997d_list.067fd2cd.jpg";